import { CancelIcon, IconCheck } from '@/assets/icons';
import { cn } from '@/utils';
import { memo } from 'react';

// Possible values of checkbox
export enum TriStateValueEnum {
	EMPTY = 'EMPTY',
	CIRCLE = 'CIRCLE',
	CROSS = 'CROSS',
}

export type TriStateCheckboxProps = {
	value: TriStateValueEnum;
	className?: string;
	name?: string;
	onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

const TriStateCheckbox = ({
	className,
	value,
	onClick,
	name,
}: TriStateCheckboxProps) => {
	const renderIcon = () => {
		switch (value) {
			case TriStateValueEnum.CIRCLE:
				return <IconCheck className="w-full h-full text-[#888]" />;
			case TriStateValueEnum.CROSS:
				return <CancelIcon className="w-full h-full" />;
			case TriStateValueEnum.EMPTY:
			default:
				return null;
		}
	};

	return (
		<div
			accessKey={name}
			className={cn('w-5 h-5 cursor-pointer', className)}
			data-value={value}
			data-name={name}
			onClick={onClick}
		>
			{renderIcon()}
		</div>
	);
};

export default memo(TriStateCheckbox);
